import React, { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import TokenRegistrationTable from "../components/TokenRegistrationTable";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import formatDate from "../utilities/formatDate";
import ApiLoader from "../components/ApiLoader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { clearUsers } from "../redux-store/slices/partyDetailsSlice";
import DummyModal from "../Modal/DummyModal";

const VirtualRegistrationTokenList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [tokenList, setTokenList] = useState([]);
  const [loading, setLoading] = useState(false);

  //   const [partyDetailsMode, setPartyDetailsMode] = useState("ALL");
  const pdeId = location?.state?.pdEid;
  const partyDetailsMode = location?.state?.mode;
  const selectedTokenDetails = location?.state?.selectedTokenDetails;
  const partyDetailsReduxData = useSelector((state) => state?.partyDetails);
  const { dcode, srocode } = useSelector((state) => state?.auth?.userDetails);
  const [openMessagePopup, setOpenMessagePopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  debugger;

  useEffect(() => {
    console.log("party details mode", partyDetailsMode);
  }, [partyDetailsMode]);

  useEffect(() => {
    handleGetRegisteredTokenData();
  }, []);

  const handleGetRegisteredTokenData = async () => {
    try {
      setLoading(true);
      debugger;

      // // Clear the existing meeting link from session storage
      // sessionStorage.removeItem("meetingLink");

      // Fetch deed details
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_deed_details_modewise_using_dcode_srocode/${dcode}/${srocode}/photo`
      );
      console.log("All token list", response.data);
      debugger;
      if (response.data?.statusCode === 200) {
        const deedDetailsList = response.data?.deedDetailsList;

        setTokenList(deedDetailsList);
        debugger;
      } else {
        toast.error(response.data?.status || "Failed to fetch deed details.");
      }
    } catch (error) {
      console.error("Error fetching registered token data:", error);
      toast.error("Unexpected error occurred. Cannot fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const registrationCombinedData = {
    dCode: dcode,
    sroCode: srocode,
    tokenNo: selectedTokenDetails?.[0]?.tokenNo || "",
    tokenDate: selectedTokenDetails?.[0]?.tokenDate || "",
    // mode:
    //   partyDetailsModeFromRegistrationTokenList === "POSTPONED"
    //     ? "Postpone"
    //     : "Registration",
    mode: "RegistrationVirtual",
    source: "New",
    // source:
    //   partyDetailsSourceFromRegistrationTokenList === "Postpone"
    //     ? "Postpone"
    //     : "New",
    refNo: 0,
    comAppName: "",
    comPCode: "",
    comAdd: "",
    commVol: "",
    commSr: "",
    commApplDate: "",
    photoImages: partyDetailsReduxData,
  };

  const handleRedirectToThumbPhotoAndSignaturePage = async (tokenNo) => {
    debugger;
    // console.log('pdEid',pdEid)
    const pdEid = tokenNo.pdEid;
    const appointmentType = tokenNo.appointmentType;
    debugger;

    console.log("selected token details", selectedTokenDetails);

    debugger;
    if (appointmentType === "V") {
      debugger;
      try {
        setLoading(true);
        const response = await axios.post(
          `${API_BASE_URL}/Registration/post_partydetails`,
          registrationCombinedData,
          {
            headers: {
              Accept: "*/*",
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response.data);
        if (response.data?.statusCode === 200) {
          debugger;
          // toast.success(response.data?.status);
          // handleGetRegYearAndRegNoWithOtherDetails(selectedTokenDetails[0]?.tokenNo)
          setSuccessMessage(response.data?.data);
          setOpenMessagePopup(true);
        }
        if (response.data?.statusCode === 400) {
          toast.error(response.data?.data?.errorMessage);
        }
      } catch (error) {
        debugger;
        console.log("Error in Final Api Submit", error);
        toast.error("Failed to Submit data due to unexpected reasons");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Appointment Types is not virtual!");
    }
  };

  const TableData = tokenList?.map((item, index) => ({
    ...item,
    sn: index + 1,
  }));
  console.log("TableData", TableData);

  const columns = [
    {
      name: "tokenNo",
      label: "Token No",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "tokenDate",
      label: "Token Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "regYear",
      label: "Registration Year",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <div className="text-start">{formatDate(value, "dd/MM/yyyy")}</div>
        ),
      },
    },
    {
      name: "deed",
      label: "Deed",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },

    {
      name: "subDeed",
      label: "Sub Deed",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "appointmentType",
      label: "appointment Type",
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },
    {
      name: "pdEid",
      label: "PDE ID",
      options: {
        display: true,
        filter: false,
        sort: true,
        customBodyRender: (value) => <div className="text-start">{value}</div>,
      },
    },

    {
      name: "pdEid",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (pdEid, tableMeta) => {
          const tokenNo = tableMeta?.rowData[0]; // Assuming 'tokenNo' is the first column
          const appointmentType = tableMeta?.rowData[5]; // Assuming 'tokenNo' is the first column
          return (
            <button
              className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
              onClick={() =>
                handleRedirectToThumbPhotoAndSignaturePage({
                  tokenNo,
                  pdEid,
                  appointmentType,
                })
              }
            >
              Verify
            </button>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false, // Disables the default download (CSV export) button
    print: false, // Disables the default print button
    viewColumns: false, // Disables the default view columns button
    search: true, // Enables the default search button
    customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  };

  const getMuiTheme = () =>
    createTheme({
      typography: {
        fontFamily: "Poppins",
      },
      palette: {
        background: {
          paper: "#ffffff",
          default: "#ffffff",
        },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            head: {
              backgroundColor: "#ffffff !important",
              color: "#929292 !important",
              padding: "10px 4px",
              borderBottom: "2px solid #ECECEC",
              borderRight: "0px solid #ddd",
              textAlign: "start",
              "& .MuiTableSortLabel-root": {
                color: "#000000 !important",
                "&.MuiTableSortLabel-active": {
                  color: "#000000 !important",
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#000000 !important",
              },
              "&:hover": {
                color: "#000000 !important",
                backgroundColor: "#ffffff !important",
              },
            },
            body: {
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "0px solid #ECECEC",
              borderRight: "0px solid #000000",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
      },
    });

  //   useEffect(() => {
  //     dispatch(clearUsers());
  //     setSelectedCheckbox(null);
  //     setPartyDetailsMode("ALL");
  //   }, []);

  return (
    <>
      {loading && <ApiLoader />}

      <div className="flex h-screen">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <Header />
          <div className="flex flex-1">
            <div className="flex-1 p-4">
              <h1 className="font-semibold text-xl">
                Virtual Registration Token
              </h1>

              <div>
                <Box width="100%">
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"Imported Token"}
                      data={TableData}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>
                </Box>
              </div>
            </div>

            <div className="w-64 h-full">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={openMessagePopup}
        onClose={() => {
          setOpenMessagePopup(false);
        }}
      >
        <DialogTitle className="bg-gray-800 text-white">
          Popup Title
        </DialogTitle>
        <DialogContent className="bg-white p-4 px-10">
          <p className="text-gray-700 text-bold">{`Your Details for Mode : ${successMessage?.mode}, Registration No : ${successMessage?.regno} and Registration Year : ${successMessage?.regYear} , Dcode : ${dcode}, SroCode :  ${srocode} saved successfully`}</p>
          {/* <p className="text-gray-700 text-bold">{`Your Details for Mode : ${successMessage?.mode}, Registration No : ${successMessage?.regno}, Dcode : ${dcode}, SroCode :  ${srocode} saved successfully`}</p> */}
        </DialogContent>
        <DialogActions className="bg-gray-100">
          <Button
            // onClick={handleMessagePopupWithPDF}
            className="bg-green-500 hover:bg-green-700 text-white py-1 px-3 rounded"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VirtualRegistrationTokenList;
